import {TimelineMax, TweenLite} from 'gsap';
const SplitText = require('../../../../viscomjs/utils/SplitText');
const elementsTracking = require('../../../../viscomjs/analytics/elementsTracking');

export default {
    name: 'app-404',
    props: {
        data: Object
    },
    computed: {
        visibility() {
            return this.entered;
        }
    },
    data() {
        return {
            entered: false,
            transitionName: 'in',
            ttlVisible: '',
            subVisible: ''
        };
    },
    mounted() {
        SplitText.wrapSymbols([this.$el.querySelector('.app-cover__ttl')], {
            cssProperty: 'transition',
            center: true,
            reverse: true,
            factor: 2,
            durationRatio: 1,
            durationMax: 1.25,
            durationMin: 0.85,
            nestingNum: 2,
            timingNestingLevel: 1
        });
        this.entered = true;

        this.startAnalytics();
    },
    beforeDestroy() {
        this.destroyAnalytics();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.transitionName = 'in';
            vm.entered = true;
        });
    },
    beforeRouteLeave(to, from, next) {
        this.transitionName = 'out';
        this.entered = false;
        this.hide();
        TweenLite.delayedCall(0.5, next);
    },
    watch: {
        visibility(to) {
            if (to) this.show();
            else this.hide();
        }
    },
    methods: {
        show() {
            const tl = new TimelineMax();
            tl.addLabel('st');
            tl.call(this.setTtlVisible, [], this, 'st+=' + 0.5);
        },
        hide() {
            const tl = new TimelineMax();
            tl.addLabel('st');
            tl.call(this.setTtlInvisible, [], this, 'st+=' + 0.15);
        },
        setTtlVisible() {
            this.ttlVisible = 'active';
        },
        setSubVisible() {
            this.subVisible = 'active';
        },
        setTtlInvisible() {
            this.ttlVisible = '';
        },
        setSubInvisible() {
            this.subVisible = '';
        },
        startAnalytics() {
            elementsTracking.init(this.$el);
        },
        destroyAnalytics() {
            elementsTracking.destroy(this.$el);
        }
    },
    template: require('../../../../../../components/templates/app-404.pug')
};
